// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__2-C1-","actionColumn":"ReferralSources_actionColumn__Ms0qs","textButton":"ReferralSources_textButton__2F1h-"};